/* Gymatics delivery progress bar: cart drawer + cart page + floating scroll bar, desktop and mobile.
   Thresholds mirror Shopify shipping settings and the "Free Delivery over £75" automatic discount (UK, 3 Nov 2026): UK + Europe (incl. RO, IS) GBP 75, US/CA GBP 60, CH/NO GBP 100, rest of world none.
   If delivery prices or free-delivery rules change, update goalsFor() below.
   Floating bar (15 Oct 2026, calmer 3 Nov 2026): slides up once after every cart change (at once, or when the drawer closes), slides
   away after 3 s and then stays hidden until the cart changes again; never on /cart or while a drawer is open; the x
   hides it until the cart changes. */
(function () {
  'use strict';
  // Words for the shop's languages (3 Nov 2026, theme v45). English is the key; {p} = amount, {n} = what it unlocks.
  var WORDS = {
    de: { 'free delivery': 'kostenlosen Versand', 'free next-day courier': 'kostenlosen Expressversand', 'free tracked delivery': 'kostenlosen Versand mit Sendungsverfolgung', 'Free delivery unlocked': 'Kostenloser Versand freigeschaltet', 'Free next-day courier unlocked': 'Kostenloser Expressversand freigeschaltet', 'Free tracked delivery unlocked': 'Kostenloser Versand mit Sendungsverfolgung freigeschaltet', add: 'Noch {p} für {n}.', away: 'Noch {p} bis {n}', item: 'Artikel', items: 'Artikel', 'View cart': 'Warenkorb ansehen', 'Progress to free delivery': 'Fortschritt bis zum kostenlosen Versand', 'Hide delivery progress': 'Versandfortschritt ausblenden' },
    fr: { 'free delivery': 'la livraison offerte', 'free next-day courier': 'la livraison express offerte', 'free tracked delivery': 'la livraison suivie offerte', 'Free delivery unlocked': 'Livraison offerte débloquée', 'Free next-day courier unlocked': 'Livraison express offerte débloquée', 'Free tracked delivery unlocked': 'Livraison suivie offerte débloquée', add: 'Plus que {p} pour {n}.', away: 'Plus que {p} pour {n}', item: 'article', items: 'articles', 'View cart': 'Voir le panier', 'Progress to free delivery': 'Progression vers la livraison offerte', 'Hide delivery progress': 'Masquer la progression' },
    it: { 'free delivery': 'la spedizione gratuita', 'free next-day courier': 'il corriere gratuito in 24 ore', 'free tracked delivery': 'la spedizione tracciata gratuita', 'Free delivery unlocked': 'Spedizione gratuita sbloccata', 'Free next-day courier unlocked': 'Corriere gratuito in 24 ore sbloccato', 'Free tracked delivery unlocked': 'Spedizione tracciata gratuita sbloccata', add: 'Aggiungi altri {p} per {n}.', away: 'Mancano {p} per {n}', item: 'articolo', items: 'articoli', 'View cart': 'Vedi carrello', 'Progress to free delivery': 'Avanzamento verso la spedizione gratuita', 'Hide delivery progress': 'Nascondi avanzamento spedizione' },
    es: { 'free delivery': 'el envío gratis', 'free next-day courier': 'el mensajero gratis en 24 h', 'free tracked delivery': 'el envío con seguimiento gratis', 'Free delivery unlocked': 'Envío gratis desbloqueado', 'Free next-day courier unlocked': 'Mensajero gratis en 24 h desbloqueado', 'Free tracked delivery unlocked': 'Envío con seguimiento gratis desbloqueado', add: 'Añade {p} más para {n}.', away: 'Te faltan {p} para {n}', item: 'artículo', items: 'artículos', 'View cart': 'Ver carrito', 'Progress to free delivery': 'Progreso hacia el envío gratis', 'Hide delivery progress': 'Ocultar progreso del envío' },
    nl: { 'free delivery': 'gratis verzending', 'free next-day courier': 'gratis koerier de volgende dag', 'free tracked delivery': 'gratis verzending met track & trace', 'Free delivery unlocked': 'Gratis verzending ontgrendeld', 'Free next-day courier unlocked': 'Gratis koerier ontgrendeld', 'Free tracked delivery unlocked': 'Gratis verzending met track & trace ontgrendeld', add: 'Nog {p} voor {n}.', away: 'Nog {p} tot {n}', item: 'artikel', items: 'artikelen', 'View cart': 'Bekijk winkelwagen', 'Progress to free delivery': 'Voortgang naar gratis verzending', 'Hide delivery progress': 'Verzendvoortgang verbergen' },
    cy: { 'free delivery': 'danfon am ddim', 'free next-day courier': 'cludwr drannoeth am ddim', 'free tracked delivery': 'danfon wedi\'i dracio am ddim', 'Free delivery unlocked': 'Danfon am ddim wedi\'i ddatgloi', 'Free next-day courier unlocked': 'Cludwr drannoeth am ddim wedi\'i ddatgloi', 'Free tracked delivery unlocked': 'Danfon wedi\'i dracio am ddim wedi\'i ddatgloi', add: 'Ychwanegwch {p} arall ar gyfer {n}.', away: '{p} yn rhagor ar gyfer {n}', item: 'eitem', items: 'eitem', 'View cart': 'Gweld y fasged', 'Progress to free delivery': 'Cynnydd tuag at ddanfon am ddim', 'Hide delivery progress': 'Cuddio cynnydd danfon' }
  };
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  function tr(s) { var w = WORDS[LANG]; return (w && w[s]) || s; }
  function fill(key, p, n, en) { var w = WORDS[LANG]; return w && w[key] ? w[key].replace('{p}', p).replace('{n}', n) : en; }
  if (window.GymaticsDeliveryProgress) return;

  // Europe zones with free tracked delivery over GBP 75 (3 Nov 2026), including RO and IS.
  // CH and NO are NOT in this list: they are in GBP100 below.
  var GBP100 = ['CH','NO'];
  var EUROPE = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IE','IS','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'];

  // Amounts in GBP pence.
  function goalsFor(country) {
    if (country === 'GB') return [
      { gbp: 7500, next: 'free delivery', done: 'Free delivery unlocked' },
      { gbp: 20000, next: 'free next-day courier', done: 'Free next-day courier unlocked' }
    ];
    if (country === 'US' || country === 'CA') return [{ gbp: 6000, next: 'free tracked delivery', done: 'Free tracked delivery unlocked' }];
    if (EUROPE.indexOf(country) !== -1) return [{ gbp: 7500, next: 'free tracked delivery', done: 'Free tracked delivery unlocked' }];
    if (GBP100.indexOf(country) !== -1) return [{ gbp: 10000, next: 'free tracked delivery', done: 'Free tracked delivery unlocked' }];
    // Rest of the world: no free-delivery promise on the shipping page, so no bar (3 Nov 2026).
    return [];
  }

  var FLOAT_SHOW_AFTER_PX = 240;   // scroll distance before the floating bar can appear
  var FLOAT_HIDE_AFTER_MS = 3000;  // how long it stays before sliding away
  var DISMISS_KEY = 'gmShipFloatDismissed';
  var SHOWN_KEY = 'gmShipFloatShown';     // cart signature it was last shown for

  var state = window.GymaticsDeliveryState || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function rate() { var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return r > 0 ? r : 1; }
  function currency() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || state.currency || 'GBP'; }
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency() }).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' ' + currency(); }
  }

  function hasGoals() { return goalsFor(String(state.country || '').toUpperCase()).length > 0; }

  function progress() {
    var total = Number(state.total) || 0;
    var r = rate();
    var goals = goalsFor(String(state.country || '').toUpperCase()).map(function (g) { return { at: Math.round(g.gbp * r), next: g.next, done: g.done }; });
    var target = null, passed = null;
    for (var i = 0; i < goals.length; i++) { if (total < goals[i].at) { target = goals[i]; break; } passed = goals[i]; }
    if (!target) return { total: total, target: null, passed: passed, last: goals[goals.length - 1], pct: 100, close: false };
    var left = target.at - total;
    return {
      total: total, target: target, passed: passed, left: left,
      pct: Math.max(2, Math.min(100, (total / target.at) * 100)),
      close: left <= target.at * 0.25
    };
  }

  function build(key) {
    var el = document.createElement('div');
    el.className = 'gm-ship gm-ship--' + key;
    el.setAttribute('data-gm-ship', key);
    el.innerHTML = '<div class="gm-ship__top"><p class="gm-ship__msg" aria-live="polite"></p><p class="gm-ship__meta"></p></div>' +
      '<div class="gm-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="' + tr('Progress to free delivery') + '"><span class="gm-ship__fill"></span></div>';
    return el;
  }

  function setText(el, sel, text) { var n = el.querySelector(sel); if (n && n.textContent !== text) n.textContent = text; }

  function setFill(el, pct) {
    el.querySelector('.gm-ship__track').setAttribute('aria-valuenow', String(Math.round(pct)));
    var fill = el.querySelector('.gm-ship__fill');
    requestAnimationFrame(function () { fill.style.width = pct.toFixed(1) + '%'; });
  }

  function paint(el) {
    if (el.getAttribute('data-gm-ship') === 'float') return paintFloat(el);
    var count = Number(state.count) || 0;
    if (count < 1 || !hasGoals()) { el.hidden = true; return; }
    el.hidden = false;
    var p = progress();
    var msg = p.target
      ? (p.passed ? tr(p.passed.done) + '! ' : '') + fill('add', money(p.left), tr(p.target.next), 'Add ' + money(p.left) + ' more for ' + p.target.next + '.')
      : tr(p.last.done) + '!';
    el.classList.toggle('is-close', p.close);
    el.classList.toggle('is-done', !p.target);
    setText(el, '.gm-ship__msg', msg);
    setText(el, '.gm-ship__meta', count + ' ' + tr(count === 1 ? 'item' : 'items') + ' · ' + money(p.total));
    setFill(el, p.pct);
  }

  /* ---------- Floating bar ---------- */

  var floatEl = null, hideTimer = null;

  function buildFloat() {
    var el = document.createElement('div');
    el.className = 'gm-float';
    el.setAttribute('data-gm-ship', 'float');
    el.setAttribute('aria-hidden', 'true');
    el.inert = true;
    el.innerHTML =
      '<button type="button" class="gm-float__open" aria-label="' + tr('View cart') + '">' +
        '<span class="gm-float__icon" aria-hidden="true">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M2.4 3h2.3l3.7 13.75 11.5-1.44L21.6 7H5.8"/><circle cx="10.5" cy="20.5" r="1.3"/><circle cx="18.5" cy="20.5" r="1.3"/></svg>' +
          '<span class="gm-float__count"></span>' +
        '</span>' +
        '<span class="gm-float__body">' +
          '<span class="gm-float__msg gm-ship__msg"></span>' +
          '<span class="gm-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="' + tr('Progress to free delivery') + '"><span class="gm-ship__fill"></span></span>' +
        '</span>' +
        '<span class="gm-float__total"></span>' +
      '</button>' +
      '<button type="button" class="gm-float__close" aria-label="' + tr('Hide delivery progress') + '">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12"/></svg>' +
      '</button>';
    el.querySelector('.gm-float__open').addEventListener('click', openCart);
    el.querySelector('.gm-float__close').addEventListener('click', dismiss);
    el.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', scheduleHide);
    el.addEventListener('focusin', function () { clearTimeout(hideTimer); });
    el.addEventListener('focusout', scheduleHide);
    return el;
  }

  function paintFloat(el) {
    if (!hasGoals()) return hideFloat();
    var count = Number(state.count) || 0;
    var p = progress();
    var msg = p.target ? fill('away', money(p.left), tr(p.target.next), money(p.left) + ' away from ' + p.target.next) : tr(p.last.done);
    el.classList.toggle('is-close', p.close);
    el.classList.toggle('is-done', !p.target);
    setText(el, '.gm-float__msg', msg);
    setText(el, '.gm-float__count', String(count));
    setText(el, '.gm-float__total', money(p.total));
    el.querySelector('.gm-float__open').setAttribute('aria-label', tr('View cart') + ': ' + count + ' ' + tr(count === 1 ? 'item' : 'items') + ', ' + money(p.total) + '. ' + msg + '.');
    setFill(el, p.pct);
    if (count < 1) hideFloat();
  }

  function readDismissed() { try { return sessionStorage.getItem(DISMISS_KEY); } catch (_) { return null; } }
  function writeDismissed(v) { try { v == null ? sessionStorage.removeItem(DISMISS_KEY) : sessionStorage.setItem(DISMISS_KEY, v); } catch (_) {} }
  var dismissedFor = readDismissed();   // cart signature at the time the x was pressed
  var shownFor = (function () { try { return sessionStorage.getItem(SHOWN_KEY); } catch (_) { return null; } })();
  function cartSig() { return (Number(state.count) || 0) + ':' + (Number(state.total) || 0); }

  function isCartPage() {
    var path = location.pathname.replace(/\/+$/, '');
    return /\/cart$/.test(path) || !!document.getElementById('main-cart-items');
  }
  function overlayOpen() {
    var drawer = document.querySelector('cart-drawer');
    return (drawer && drawer.classList.contains('active')) || document.body.classList.contains('overflow-hidden');
  }

  function eligible() {
    if ((Number(state.count) || 0) < 1 || !hasGoals()) return false;
    if (dismissedFor && dismissedFor === cartSig()) return false;
    if (shownFor && shownFor === cartSig() && !(floatEl && floatEl.classList.contains('is-visible'))) return false;
    if (isCartPage() || overlayOpen()) return false;
    return true;
  }

  function showFloat() {
    if (!floatEl || !eligible()) return hideFloat();
    paintFloat(floatEl);
    floatEl.inert = false;
    floatEl.removeAttribute('aria-hidden');
    if (!floatEl.classList.contains('is-visible')) {
      shownFor = cartSig();
      try { sessionStorage.setItem(SHOWN_KEY, shownFor); } catch (_) {}
      floatEl.classList.add('is-visible');
      scheduleHide();   // one timer per showing: scrolling no longer keeps it up
    }
  }

  function hideFloat() {
    clearTimeout(hideTimer);
    if (!floatEl) return;
    if (floatEl.contains(document.activeElement)) document.activeElement.blur();
    floatEl.classList.remove('is-visible');
    floatEl.setAttribute('aria-hidden', 'true');
    floatEl.inert = true;
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (floatEl && (floatEl.matches(':hover') || floatEl.contains(document.activeElement))) return scheduleHide();
      hideFloat();
    }, FLOAT_HIDE_AFTER_MS);
  }

  function dismiss() {
    dismissedFor = cartSig();
    writeDismissed(dismissedFor);
    hideFloat();
  }

  function openCart(event) {
    hideFloat();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('is-empty')) {
      drawer.open(event && event.currentTarget);
    } else {
      location.href = root + 'cart';
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (window.scrollY < FLOAT_SHOW_AFTER_PX) return hideFloat();
      showFloat();
    });
  }

  function startFloat() {
    if (isCartPage() || state.noFloat) return;
    floatEl = buildFloat();
    document.body.appendChild(floatEl);
    paintFloat(floatEl);
    window.addEventListener('scroll', onScroll, { passive: true });
    // Hide straight away if a drawer/menu opens while the bar is up.
    new MutationObserver(function () {
      if (overlayOpen()) return hideFloat();
      if (shownFor !== cartSig() && eligible()) showFloat();   // drawer just closed after a cart change
    })
      .observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Shared ---------- */

  function paintAll() { document.querySelectorAll('[data-gm-ship]').forEach(paint); }

  function mounts() {
    var list = [];
    var header = document.querySelector('#CartDrawer .drawer__header');
    if (header && header.parentNode) list.push({ key: 'drawer', parent: header.parentNode, anchor: header, where: 'afterend' });
    var footer = document.querySelector('#main-cart-footer .js-contents') || document.querySelector('#main-cart-footer .cart__blocks');
    if (footer) list.push({ key: 'page', parent: footer, anchor: footer, where: 'afterbegin' });
    return list;
  }

  // Inserts the bar wherever it is missing (theme re-renders the drawer and cart totals on every change).
  function ensure() {
    var inserted = false;
    mounts().forEach(function (m) {
      if (m.parent.querySelector(':scope > [data-gm-ship]')) return;
      var el = build(m.key);
      m.anchor.insertAdjacentElement(m.where, el);
      paint(el);
      inserted = true;
    });
    return inserted;
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var before = cartSig();
          state.total = cart.total_price;
          state.count = cart.item_count;
          if (cart.currency) state.currency = cart.currency;
          // A changed cart brings the floating bar back even if it was dismissed.
          if (dismissedFor && dismissedFor !== cartSig()) { dismissedFor = null; writeDismissed(null); }
          paintAll();
          // Every cart change slides the bar up once, straight away (or as soon as the drawer closes).
          if (cartSig() !== before && floatEl) showFloat();
        })
        .catch(function () {});
    }, 120);
  }

  function start() {
    ensure();
    startFloat();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; if (ensure()) refresh(); });
    }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  }

  window.GymaticsDeliveryProgress = { refresh: refresh, showFloat: showFloat, hideFloat: hideFloat };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
